export default {

  meta: {
    home: {
      title: 'DITAP - Smart Tap Solution for Digital Identity',
      description: 'DITAP brings NFC-based Smart Tap Solution for digital identity, contact info, and business needs.',
      keywords: 'ditap, smart tap, nfc, digital identity'
    },
    about: {
      title: 'About DITAP - Smart Tap Solution for Digital Identity',
      description: 'Get to know DITAP, an NFC solution that connects digital identity for personal and business needs.',
      keywords: 'about ditap, smart tap, nfc, digital identity'
    },
    howItWorks: {
      title: 'How DITAP Works - 6 Easy Steps with NFC',
      description: 'Learn how DITAP works: tap your NFC card to open your digital profile. Set up in minutes, no app required.',
      keywords: 'how ditap works, nfc, smart tap, digital profile'
    },
    contact: {
      title: 'Contact DITAP - WhatsApp, Email, or Social Media',
      description: 'Contact the DITAP team via WhatsApp, email, Instagram, or TikTok for questions about our smart tap solution.',
      keywords: 'contact ditap, ditap whatsapp, ditap support'
    },
    faq: {
      title: 'FAQ - Frequently Asked Questions | DITAP',
      description: 'Find answers about DITAP, NFC technology, QR Code, account activation, and digital identity services.',
      keywords: 'ditap faq, nfc, qr code, account activation'
    },
    blog: {
      title: 'DITAP Blog - Smart Tap & Digital Identity Articles',
      description: 'Read the latest articles about smart tap solutions, NFC, QR Code, and digital identity from the DITAP team.',
      keywords: 'ditap blog, nfc articles, qr code articles'
    },
    blogDetail: {
      titleSuffix: 'DITAP Blog',
      loading: 'Loading article...',
      notFound: 'Article not found'
    },
    privacyPolicy: {
      title: 'Privacy Policy - DITAP',
      description: 'Read the DITAP privacy policy to understand how we collect, use, and protect your personal information.',
      keywords: 'ditap privacy policy, data protection'
    },
    terms: {
      title: 'Terms & Conditions - DITAP',
      description: 'Read the terms and conditions for using DITAP services.',
      keywords: 'ditap terms, terms of service'
    },
    notFound: {
      title: 'Page not found - DITAP',
      description: 'The page you are looking for was not found.'
    },
    login: {
      title: 'Login - DITAP',
      description: 'Sign in to your DITAP account.'
    },
    activateAccount: {
      title: 'Activate Account - DITAP',
      description: 'Activate your DITAP account using the activation code from your DITAP product.',
      keywords: 'activate ditap account, ditap activation'
    },
    forgotPassword: {
      title: 'Forgot Password - DITAP',
      description: 'Reset your DITAP account password with email verification.',
      keywords: 'forgot ditap password, reset ditap password'
    },
    resetPassword: {
      title: 'Reset Password - DITAP',
      description: 'Create a new password for your DITAP account.',
      keywords: 'reset ditap password, change ditap password'
    }
  },
    
  navbar: {
    home: 'Home',
    about: 'About',
    works: 'How It Works',
    pricing: 'Pricing',
    contact: 'Contact',
    login: 'Login'
  },

  footer: {
    description: 'DITAP connects the physical and digital worlds through NFC solutions for personal and business needs.',
  
    navigationTitle: 'Navigation',
    informationTitle: 'Information',
    contactTitle: 'Contact Us',
  
    blog: 'Blog',
    faq: 'FAQ',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
  
    contactDescription: 'Have a question or an interesting idea? Let’s talk.',
  
    rights: 'All rights reserved.'
  },

  hero: {
    eyebrow: 'SMART TAP SOLUTIONS',
    title: 'JUST TAP',
    highlight: 'IT.',
    subtitle: 'Connecting the physical and digital worlds.',
    description: 'DITAP offers NFC-powered solutions for personal and business needs, making information access and interactions more convenient with just one tap.',
    exploreProducts: 'Explore Products',
    howItWorks: 'How It Works',
    visualCaption: 'ONE TAP. MORE POSSIBILITIES.'
  },

  b2bProof: {
    eyebrow: 'SMART SOLUTIONS FOR BUSINESS',
    title: 'Smart Choices for',
    highlight: 'Modern Businesses.',
    subtitle: 'Moving forward with businesses.',
    description: 'DITAP helps businesses connect physical products with digital information and customer experiences through practical NFC solutions.'
  },

  b2cProof: {
    eyebrow: 'SMART TAP SOLUTION',
    progressLabel: 'Choose content',
    showSlide: 'Show content {number}',

    slides: {
      convenience: {
        title: 'Convenience for everyday life.',
        description: 'The right solutions make everyday activities simpler and more convenient.',
        imageAlt: 'A smartphone as part of everyday digital activities'
      },

      connected: {
        title: 'Helping lost items find their way home.',
        description: 'Every returned item has a story of its own.',
        imageAlt: 'A modern smartphone accessing digital services'
      },

      possibilities: {
        title: 'More possibilities with DITAP.',
        description: 'More diverse needs create more opportunities to explore.',
        imageAlt: 'Digital technology supporting everyday activities'
      }
    }
  },

  faq: {
    eyebrow: 'FREQUENTLY ASKED QUESTIONS',
    title: 'Have questions? We’re here to help.',
    description: 'Find answers about DITAP, NFC technology, and how to use our products.',
  
    contactButton: 'Contact Us',
    whatsappMessage: 'Hello DITAP, I would like to ask about your products.',
  
    questions: {
      what: {
        question: 'What is DITAP?',
        answer: 'We focus on solutions that are simple to use, easy to access, and adaptable to both personal and business needs.',
      },
  
      how: {
        question: 'How does DITAP work?',
        answer: 'Simply bring an NFC-compatible phone close to a DITAP product. Your phone will open the digital link or page connected to that product.'
      },
  
      tracking: {
        question: 'Can DITAP track the location of lost items?',
        answer: 'No. DITAP is not a GPS tracker and cannot show an item’s live location. Depending on the product, DITAP can help someone who finds an item access contact information shared by its owner.'
      },
  
      compatibility: {
        question: 'Does DITAP work with every phone?',
        answer: 'DITAP works with phones that support NFC. NFC availability and activation steps may vary depending on the device.'
      },
  
      order: {
        question: 'How can I purchase DITAP products?',
        answer: 'Contact the DITAP team for information about available products, pricing, and how to place an order.'
      }
    }
  },

  howItWorks: {
    eyebrow: 'HOW IT WORKS — DITAP',
    title: 'As Easy as One Tap.',
    description: 'From physical products to digital experiences, DITAP connects the physical world with digital information through NFC technology.',

    stepLabel: 'STEP {number}',

    steps: {
      choose: {
        caption: 'Choose a product',
        title: 'Choose the Right Solution',
        description: 'Discover DITAP products designed for both personal and business needs.'
      },

      tap: {
        caption: 'Tap with your smartphone',
        title: 'Tap with Your Smartphone',
        description: 'Bring an NFC-enabled smartphone close to your DITAP product to open its linked page or information.'
      },

      access: {
        caption: 'Access information',
        title: 'Enjoy Digital Benefits',
        description: 'Access information or digital experiences based on the function of your chosen product.'
      }
    },

    ctaLabel: 'READY TO GET STARTED?',
    ctaTitle: 'Make everyday interactions simpler.',
    ctaDescription: 'Discover the DITAP solution that fits your needs.',
    ctaButton: 'Explore DITAP Products'
  },

  cta: {
    eyebrow: 'JUST TAP IT.',
    title: 'Find the Right',
    highlight: 'Solution for You.',
    description: 'Discover NFC solutions for your everyday life and business. Simple, practical, and connected with just one tap.',

    personal: {
      category: 'PERSONAL',
      title: 'For Personal Use',
      description: 'Make everyday activities easier with practical NFC solutions designed for your personal needs.',
      button: 'Explore Personal'
    },

    business: {
      category: 'BUSINESS',
      title: 'For Your Business',
      description: 'Connect your products with digital experiences and make customer interactions more convenient.',
      button: 'Explore Business'
    },

    howItWorks: {
      eyebrow: 'READY TO GET STARTED?',
      title: 'Make everything',
      highlight: 'easier with DITAP.',
      description:
        'Activate your account, personalize your digital page, and give your customers a more convenient experience with NFC technology.',
      primaryButton: 'Get Started',
      secondaryButton: 'Contact Our Team',
      benefits: {
        easy: 'Easy to use',
        practical: 'Easy to manage',
        nfc: 'Powered by NFC',
      },
  },
  },

  // About

  aboutHero: {
    eyebrow: 'ABOUT DITAP',
    title: 'Connecting the',
    highlight: 'Physical and Digital.',
    description: 'DITAP delivers NFC-powered solutions that make accessing information and connecting with others easier for both personal and business needs.',
    primaryButton: 'Explore Products',
    secondaryButton: 'Contact Us',
    signature: 'SIMPLE TECHNOLOGY. PRACTICAL BENEFITS.'
  },

  aboutIntro: {
    status: 'Ready to use',
    productLabel: 'Connectivity solution',
    productName: 'NFC',

    floatOneTitle: 'More convenient',
    floatOneText: 'Access with one tap',

    floatTwoTitle: 'Direct connection',
    floatTwoText: 'From physical to digital',

    eyebrow: 'GET TO KNOW DITAP',
    title: 'Technology that',
    highlight: 'Makes Connection Easier.',
    description: 'DITAP makes interactions between the physical and digital worlds easier. With NFC technology, information can be accessed in a faster and more convenient way.',
    detail: 'We focus on solutions that are simple to use, easy to access, and adaptable to both personal and business needs.',
    featureOne: 'Access information without an extra app',
    featureTwo: 'Works with NFC technology',
    featureThree: 'Flexible solutions for different needs',

    signature: 'BUILT TO MAKE CONNECTIONS EASIER'
  },

  aboutFeatures: {
    eyebrow: 'WHY DITAP',
    title: 'One Tap,',
    highlight: 'More Possibilities.',
    description: 'We combine practical technology with a digital experience that is easier to access.',

    cardOneTitle: 'NFC Technology',
    cardOneDescription: 'Simply tap a compatible phone to open a prepared link or information page.',
    cardOneTag: 'TAP & CONNECT',

    cardTwoTitle: 'One Simple Tap',
    cardTwoDescription: 'Bring your phone close to a DITAP NFC plate to open a Google review page instantly, without an additional app.',
    cardTwoTag: 'TAP & REVIEW',

    cardThreeTitle: 'Flexible for Different Needs',
    cardThreeDescription: 'Solutions that direct users to digital pages for personal or business purposes.',
    cardThreeTag: 'FLEXIBLE SOLUTIONS',

    bottomText: 'Designed to make digital experiences more convenient.'
  },

  aboutVision: {
    eyebrow: 'OUR DIRECTION AND PURPOSE',
    title: 'Technology with',
    highlight: 'A Clear Purpose.',
    description: 'We want technology to connect people and make everyday interactions simpler.',

    visionLabel: 'OUR VISION',
    visionTitle: 'Making connections easier.',
    visionText: 'To be part of a practical, accessible digital experience that remains relevant to everyday needs.',

    missionLabel: 'OUR MISSION',
    missionTitle: 'Starting with the simple things.',
    missionDescription: 'We focus on three key principles when developing DITAP solutions.',

    missionOneTitle: 'Prioritize convenience',
    missionOneText: 'Provide practical ways to connect users with digital information.',

    missionTwoTitle: 'Use NFC technology',
    missionTwoText: 'Leverage NFC to make information access more flexible.',

    missionThreeTitle: 'Support user needs',
    missionThreeText: 'Develop solutions adaptable to personal and business requirements.',

    footerText: 'Useful technology starts with an effortless experience.'
  },

  aboutCTA: {
    eyebrow: 'YOUR NEXT STEP',
    title: 'Ready to Make Things',
    highlight: 'More Convenient?',
    description: 'Explore DITAP solutions and discover easier ways to connect the physical world with digital experiences.',

    primaryButton: 'Explore Products',
    secondaryButton: 'Contact Us',

    note: 'Find a solution that fits your needs.',
    footer: 'JUST TAP IT. — CONNECT PHYSICAL TO DIGITAL.'
  },

  // How It Works

  howItWorksHero: {
    eyebrow: 'HOW DITAP WORKS',
    title: 'One tap,',
    highlight: 'everything made easy.',
    description: 'DITAP uses NFC technology to connect customers to the digital pages you need in a simple, convenient way.',
    primaryButton: 'View Pricing',
    secondaryButton: 'Contact Us',
    cardLabel: 'DITAP NFC SOLUTION',
    cardTitle: 'More convenient,',
    cardHighlight: 'just one tap.',
    cardDescription: 'Connect your DITAP product to a digital page and give your customers a quick, seamless experience.',
    nfcBenefit: 'Access digital pages through NFC',
    easyBenefit: 'Convenient, with no extra app',
    cardFooter: 'BUILT FOR MODERN BUSINESSES',
    productImageAlt: 'DITAP NFC product',
    imagePlaceholder: 'DITAP product image',
    nfcTitle: 'NFC Technology',
    nfcDescription: 'Simply tap your phone',
    easyTitle: 'Instant connection',
    easyDescription: 'Access a digital page',
    bottomLeft: 'BUILT FOR MODERN BUSINESSES',
    bottomRight: 'POWERED BY NFC TECHNOLOGY'
  },


howItWorksSteps: {
  eyebrow: 'HOW DITAP WORKS',
  title: 'Get started,',
  highlight: 'it is that simple.',
  description:
    'Follow this guide to activate your account, customize your digital page, and start using your DITAP product.',
  stepLabel: 'STEP',
  visualVisit: 'Visit',
  visualRegister: 'Sign up',
  visualDashboard: 'Dashboard ready',

  steps: {
    product: {
      title: 'Get to know DITAP',
      description:
        'DITAP connects customers to your business digital page through NFC technology. Learn how your product works before getting started.',
      footer: 'START WITH DITAP',
    },

    website: {
      title: 'Visit the DITAP website',
      description:
        'Open the official DITAP website in your browser to begin registration and access the available services.',
      footer: 'VISIT THE OFFICIAL WEBSITE',
    },

    register: {
      title: 'Register and create an account',
      description:
        'Complete the registration form with the required information to create an account and manage your digital page.',
      footer: 'ACCOUNT REGISTRATION',
    },

    dashboard: {
      title: 'Sign in to your dashboard',
      description:
        'Log in with your registered account. From your dashboard, you can access settings and manage your DITAP page.',
      footer: 'MANAGE YOUR ACCOUNT',
    },

    edit: {
      title: 'Edit and customize your page',
      description:
        'Customize your digital page information and destination links. Review your changes and save them before use.',
      footer: 'SAVE YOUR CHANGES',
    },

    tap: {
      title: 'Use your DITAP product',
      description:
        'Once your product is ready, bring an NFC-compatible phone close to your DITAP product to open the linked digital page.',
      footer: 'READY TO USE',
    },
  },

  note:
    'Note: If your DITAP product is already linked to your digital page when delivered, you do not need to configure NFC again. Make sure your digital page is correct before sharing it with customers.',
},


  
  contact: {
    eyebrow: 'Contact Us',
    title: 'How can we help you?',
    description: 'Contact the Ditap team for questions, product information, or business inquiries.',
  
    infoTitle: 'Contact Information',
    infoDescription: 'Choose the most convenient way to reach us.',
  
    whatsappTitle: 'WhatsApp',
    emailTitle: 'Email',
  
    formTitle: 'Send a Message',
    formDescription: 'Fill out the form below to send your message directly through WhatsApp.',
  
    nameLabel: 'Name',
    namePlaceholder: 'Enter your name',
  
    emailLabel: 'Email',
    emailPlaceholder: "name{'@'}email.com",
  
    messageLabel: 'Message',
    messagePlaceholder: 'Write your message here',
  
    submitButton: 'Send via WhatsApp',
    privacyNote: 'Your message will be forwarded to Ditap WhatsApp.'
},

  terms: {
    hero: {
      eyebrow: 'Terms of Service',
      title: 'Terms &',
      highlight: 'Conditions',
      description: 'Please read these terms and conditions before using DITAP services.'
    },

    lastUpdated: 'Last updated:',
    tocTitle: 'Table of Contents',

    notice: 'By accessing or using DITAP services, you acknowledge that you have read and understood the applicable terms and conditions.',

    sections: {
      introduction: {
        title: 'Introduction',
        p1: 'DITAP provides NFC-based solutions that help businesses direct customers to review pages through compatible devices.',
        p2: 'These terms and conditions govern the use of the DITAP website and services. By accessing or using our services, you agree to comply with the applicable terms.'
      },

      acceptance: {
        title: 'Acceptance of Terms',
        p1: 'By accessing the website or using DITAP services, you acknowledge that you have read and understood these terms and conditions.',
        p2: 'If you do not agree to these terms, please refrain from using the relevant services.'
      },

      services: {
        title: 'DITAP Services',
        p1: 'DITAP provides NFC solutions that can open destination links, including business review pages selected by users or business owners.',
        p2: 'Service features, availability, and terms may change as the product develops. Information about specific features is subject to the descriptions available when the service is used.'
      },

      nfc: {
        title: 'NFC Usage',
        p1: 'NFC functionality depends on device compatibility, phone settings, and the technical condition of the device being used. Users should ensure their devices support NFC when this feature is required.',
        p2: 'DITAP does not guarantee that every device will open links in the same way. The user experience may also be affected by internet connectivity and destination services.'
      },

      responsibilities: {
        title: 'User Rights and Responsibilities',
        p1: 'When using DITAP services, you are responsible for:',
        l1: 'Providing accurate information when contacting us or using our services.',
        l2: 'Using the services for lawful purposes and in compliance with applicable laws.',
        l3: 'Not misusing the services, attempting to disrupt systems, or accessing unauthorized areas.',
        l4: 'Ensuring that any destination links you use are consistent with the rights and permissions you hold.'
      },

      intellectualProperty: {
        title: 'Intellectual Property',
        p1: 'The DITAP name, logo, designs, visual elements, and other materials owned by DITAP are protected by applicable intellectual property laws.',
        p2: 'You may not copy, distribute, modify, or use DITAP materials beyond the permissions granted or what is permitted by applicable law.'
      },

      thirdParty: {
        title: 'Third-Party Services',
        p1: 'DITAP services may direct users to third-party platforms, including business review services. These platforms have their own terms and policies.',
        p2: 'DITAP does not control all third-party services, content, availability, or policies. Use of those platforms is subject to the relevant providers’ terms.'
      },

      availability: {
        title: 'Service Availability',
        p1: 'We strive to keep our services available, but we do not guarantee that the website or all features will always operate without interruption. Maintenance, network issues, and circumstances beyond our control may affect service availability.'
      },

      liability: {
        title: 'Limitation of Liability',
        p1: 'To the extent permitted by applicable law, DITAP is not responsible for interruptions caused by user devices, networks, or third-party services outside our direct control.',
        p2: 'Nothing in these terms is intended to exclude rights or responsibilities that cannot be excluded under applicable law.'
      },

      changes: {
        title: 'Changes to These Terms',
        p1: 'DITAP may update these terms and conditions from time to time. Changes will be displayed on this page alongside the relevant update date. Use of the services after changes are posted is subject to the applicable terms, to the extent permitted by law.'
      },

      contact: {
        title: 'Contact Us',
        p1: 'If you have questions about these terms and conditions, please contact us by email at {email}.'
      }
    },

    contact: {
      eyebrow: 'Need Help?',
      title: 'Questions about our terms?',
      description: 'Contact the DITAP team if you need further clarification about our service terms and conditions.',
      button: 'Contact Us'
    }
  },

  privacyPolicy: {
    hero: {
      eyebrow: 'Your Privacy',
      title: 'Privacy',
      highlight: 'Policy',
      description: 'We value your privacy. This page explains how information may be processed when you access the DITAP website and services.'
    },

    lastUpdated: 'Last updated:',
    tocTitle: 'Table of Contents',

    notice: 'This policy describes DITAP’s general privacy principles. The information actually processed depends on the features you use and the third-party services involved.',

    sections: {
      overview: {
        title: 'Introduction',
        p1: 'DITAP provides NFC-based solutions that help customers access business review pages through compatible devices.',
        p2: 'This policy explains general information-handling principles, service usage, and choices relating to privacy.'
      },

      information: {
        title: 'Information That May Relate to Our Services',
        p1: 'The types of information that may be processed depend on how you use the services. This information may include:',
        l1: 'Information you provide directly when contacting us, such as your name, email address, and message contents.',
        l2: 'Technical information that may be processed by the website or hosting provider, such as browser type, device information, IP address, and access logs, depending on the service configuration.',
        l3: 'Information processed by third-party platforms when you access their services through links from DITAP.'
      },

      usage: {
        title: 'How Information May Be Used',
        p1: 'Where information is processed through the use of our services, it may be used for relevant purposes, including:',
        l1: 'Responding to questions, feedback, or support requests.',
        l2: 'Operating, maintaining, and improving the DITAP website and services.',
        l3: 'Helping maintain security, detect misuse, and address technical issues.',
        l4: 'Complying with applicable legal obligations where required.'
      },

      nfc: {
        title: 'NFC and Review Pages',
        p1: 'DITAP NFC plates are designed to help compatible devices open a destination link, such as a business review page. Using NFC does not, by itself, give DITAP access to all the contents of your phone.',
        p2: 'Once a link is opened, information processing on the destination page is governed by the relevant platform’s policies and settings. DITAP does not control all data-collection practices of those external platforms.'
      },

      thirdParties: {
        title: 'Third-Party Services and Links',
        p1: 'The DITAP website or its links may direct you to third-party services, including review platforms. Those services have their own privacy policies and terms.',
        p2: 'We encourage you to review the relevant platform’s privacy policy before providing information or using its features. Third-party privacy practices are outside DITAP’s direct control.'
      },

      security: {
        title: 'Information Security',
        p1: 'Information protection should be appropriate to the type of data and how it is processed. DITAP aims to apply reasonable measures appropriate to the services used, but no electronic transmission or storage method can be guaranteed to be completely secure.'
      },

      retention: {
        title: 'Information Retention',
        p1: 'The retention period for information, if any, depends on its purpose, operational needs, and applicable legal obligations. Information should not be retained longer than necessary for a legitimate purpose.'
      },

      rights: {
        title: 'Your Choices and Rights',
        p1: 'Depending on applicable law and the circumstances of processing, you may submit requests concerning personal information you have provided to DITAP, including:',
        l1: 'Requesting information about how your personal data is used.',
        l2: 'Requesting correction or deletion of relevant information where feasible and consistent with legal obligations.',
        l3: 'Submitting questions or objections regarding the processing of personal information.'
      },

      children: {
        title: 'Children’s Privacy',
        p1: 'The DITAP website is not specifically directed at children. If you believe a child has provided personal information to us, please contact us so the situation can be reviewed.'
      },

      changes: {
        title: 'Changes to This Policy',
        p1: 'We may update this privacy policy from time to time. Changes will be displayed on this page alongside the relevant update date. We encourage you to review this page periodically.'
      },

      contact: {
        title: 'Contact Us',
        p1: 'If you have questions about this privacy policy or wish to submit a request concerning personal information, contact us by email at {email}.'
      }
    },

    contact: {
      eyebrow: 'Need Help?',
      title: 'Questions about privacy?',
      description: 'Contact the DITAP team if you have questions about this privacy policy or personal information.',
      button: 'Contact Us'
    }
  },

  blog: {
    hero: {
      eyebrow: 'DITAP JOURNAL',
      title: 'Digital insights for',
      highlight: 'a more connected world.',
      description: 'Discover inspiration on NFC technology, digital identity, and practical solutions for individuals and businesses.'
    },
    searchPlaceholder: 'Search articles...',
    searchLabel: 'Search blog articles',
    searchButton: 'Search',
    articlesEyebrow: 'EXPLORE IDEAS',
    latestTitle: 'Latest articles',
    latestDescription: 'Knowledge to power your next digital step.',
    articleCount: 'articles',
    allCategories: 'All articles',
    readMore: 'Read more',
    errorTitle: 'Articles could not be loaded',
    errorDescription: 'Something went wrong while fetching articles.',
    retry: 'Try again',
    noResultsTitle: 'No articles found',
    noResultsDescription: 'Try a different keyword.',
    emptyTitle: 'Our first story is coming soon',
    emptyDescription: 'We are preparing exciting insights on NFC and digital identity.',
    resetFilters: 'Show all articles',
    paginationLabel: 'Blog pagination',
    previous: 'Previous',
    next: 'Next',

    backToBlog: 'Back to Blog',
    detailErrorTitle: 'Unable to Load Article',
    readingMinutes: 'min read',
    emptyContent: 'Article content is not available yet.',
    tagsLabel: 'Topics:',
    relatedEyebrow: 'KEEP READING',
    relatedTitle: 'Related Articles',
    viewAll: 'View all',
    notFoundDescription: 'The article you are looking for could not be found.',
    // errorDescription: 'Something went wrong while fetching the article.',
    // retry: 'Try again'
  },

  faqPage: {
    hero: {
      eyebrow: 'DITAP HELP CENTER',
      title: 'How can we',
      highlight: 'help you?',
      description:
        'Find answers to questions about DITAP, NFC technology, QR Code, and our digital identity services.'
    },
  
    searchPlaceholder: 'Search questions...',
    searchLabel: 'Search FAQ questions',
    searchButton: 'Search',
  
    questionsEyebrow: 'GENERAL QUESTIONS',
    latestTitle: 'Frequently asked questions',
    latestDescription:
      'Quick answers to the most common questions about DITAP.',
  
    questionCount: 'questions',
  
    tabs: {
      umum: 'General',
      bisnis: 'Business'
    },
  
    emptyTitle: 'No questions yet',
    emptyDescription: 'Please check back later.',
    noResultsTitle: 'No questions found',
    noResultsDescription:
      "We couldn't find a matching question. Try another keyword.",
    resetFilters: 'Reset search',
  
    previous: 'Previous',
    next: 'Next',
    paginationLabel: 'FAQ page navigation',
  
    questions: {
      what: {
        question: 'What is DITAP?',
        answer:
          'DITAP is a digital identity platform that lets users share digital profiles and information through NFC and QR Code technology.'
      },
      purpose: {
        question: 'What is the main purpose of DITAP?',
        answer:
          'DITAP makes it easy to share identity and digital information instantly. One tap or scan is all it takes to open a digital page.'
      },
      nfc: {
        question: 'What is NFC technology in DITAP?',
        answer:
          'NFC (Near Field Communication) is a short-range communication technology that allows a smartphone to read an NFC tag by bringing the device close to it.'
      },
      compatibility: {
        question: 'Can every smartphone use NFC?',
        answer:
          'Not every smartphone supports NFC. The device must support NFC reading and the feature must be enabled. If your phone does not support NFC, you can still access the DITAP page via QR Code.'
      },
      app: {
        question: 'Do I need to install an app to use NFC?',
        answer:
          'On smartphones that support NFC reading, you generally do not need to install any additional app. Simply tap your phone against the DITAP NFC product to open the digital link.'
      },
      qr: {
        question: 'Does DITAP support QR Code?',
        answer:
          'Yes. DITAP supports QR Code access so users can open the digital page by scanning the code with their smartphone camera.'
      },
      activation: {
        question: 'How do I activate my DITAP account?',
        answer:
          'Use the activation code provided with your DITAP product. Follow the activation steps to set up your identity and account information.'
      },
      profile: {
        question: 'Can I update my profile information?',
        answer:
          'Yes. Once your account is active, you can manage and update your digital page information through your DITAP account, according to the available features.'
      },
      privacy: {
        question: 'Is my personal information secure?',
        answer:
          'DITAP is committed to keeping user information safe. We recommend not sharing your activation code or login details with anyone else.'
      },
      update: {
        question:
          'Do I need to replace the NFC card when I update my profile?',
        answer:
          'No. As long as the digital link remains the same and the NFC product works properly, profile information can be updated without rewriting the NFC card.'
      }
    },
  
    bisnisQuestions: {
      pricing: {
        question: 'How does pricing work for business needs?',
        answer:
          'DITAP offers business plans that can be tailored to the number of NFC cards, users, and integration needs. Contact our sales team for an official quote.'
      },
      plan: {
        question:
          'What is the difference between personal and business plans?',
        answer:
          'Business plans include additional features such as team management, visit analytics, custom branding, and priority support that are not available on personal plans.'
      },
      invoice: {
        question:
          'Are official invoices available for corporate purchases?',
        answer:
          'Yes. Every business plan purchase comes with an official invoice that can be used for corporate administration and tax purposes.'
      },
      refund: {
        question: 'What is the refund policy for business plans?',
        answer:
          'Refunds follow the terms applicable at the time of purchase. Please contact our support team for more details according to your contract.'
      },
      seats: {
        question: 'Can I add more users later?',
        answer:
          'Absolutely. Business plans are flexible, so you can add users at any time and billing will be adjusted proportionally.'
      },
      roles: {
        question: 'Are team roles and permissions configurable?',
        answer:
          'Yes. The main admin can configure team member roles, including access rights to manage profiles, NFC cards, and analytics reports.'
      },
      api: {
        question: 'Does DITAP provide an API for integration?',
        answer:
          "Business plans support API access so you can integrate DITAP digital identity data with your company's internal systems."
      },
      crm: {
        question: 'Can DITAP connect with our CRM?',
        answer:
          'DITAP can be integrated with popular CRMs through APIs or middleware. Our team can help with the integration based on your needs.'
      },
      sla: {
        question: 'Is there an SLA guarantee for business clients?',
        answer:
          'Yes. Business clients receive SLA guarantees with faster support response times than personal plans, as defined in the contract.'
      },
      contact: {
        question: 'How do I contact the business sales team?',
        answer:
          'You can reach the sales team via the Contact Us button on this page, or by emailing the official address listed on our contact page.'
      }
    }
  },

  notFound: {
    title: 'Page not found',
    description: "Sorry, the page you are looking for doesn't exist or may have been moved.",
    button: 'Back to Home'
  }
}
